import { gql, useLazyQuery } from "@apollo/client"
import { examScoreResult } from "./useLazyPlan"

const useLazyScoreByPlan = (variables = {}) => {
    return useLazyQuery(
        gql`
            query (
                $planId: ID!
            ) {
                getScoresByPlanId (
                    planId: $planId
                ) {
                    id
                    planId
                    taskId
                    examId
                    name
                    examScoreId
                    studentId
                    serviceId
                    examDate
                    overall
                    ${examScoreResult}
                }
            }
        `,
        { variables }
    )
}

export default useLazyScoreByPlan